<template>
  <div>
    <Header />
    <Tabs v-if="settingConfig.tabs" />
  </div>
  <el-container class="container-main">
    <el-aside>
      <Menu />
    </el-aside>
    <el-container>
      <el-main>
        <RouterView />
      </el-main>
      <el-footer class="container-footer" v-if="settingConfig.footer">
        <Footer />
      </el-footer>
      <el-backtop target=".el-main" :right="80" :bottom="80" />
    </el-container>
  </el-container>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue'
import { GlobalStore } from '@/store/modules/global'
import { MenuStore } from '@/store/modules/menu'
import { useWindowSize } from '@vueuse/core'
import { RouterView } from 'vue-router'
import { storeToRefs } from 'pinia'
import Menu from './menus/index.vue'
import Header from './header/index.vue'
import Tabs from './tabs/index.vue'
import Footer from './footer/index.vue'

const globalStore = GlobalStore()
const menuStore = MenuStore()
const settingConfig = storeToRefs(globalStore).settingConfig

const handleResize = () => {
  const { width } = useWindowSize()
  if (width.value <= 800) {
    menuStore.toggleCollpase(true)
  } else {
    menuStore.toggleCollpase(false)
  }
}

onMounted(() => {
  window.addEventListener('resize', () => handleResize())
})

onUnmounted(() => {
  window.removeEventListener('resize', () => handleResize())
})
</script>

<style lang="scss" scoped>
.el-container.container-main {
  min-height: calc(100% - 56px);
}

.el-container {
  width: 100%;
  min-width: 970px;
  // height: 100%;
  box-sizing: border-box;
  .el-aside {
    width: auto;
    overflow: inherit;
  }
  .el-header,
  .el-footer {
    height: auto;
    padding: 0;
  }
  .el-main {
    box-sizing: border-box;
    // padding: 10px 12px;
    font-size: 14px;
    padding: 0;
    overflow-x: hidden;
    background: #f7f7f8;
    &::-webkit-scrollbar {
      background-color: #f0f2f5;
    }
  }
  .container-footer {
    height: 30px;
    background: #ffffff;
    border-top: 1px solid #e4e7ed;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
:deep(.el-backtop__icon) {
  color: #fa4756;
}
</style>
